import { StatusType } from '../pages/ApplicationPage/types';
import { LanguageType, PublisherType, SchoolClassType, SubjectAreaType } from '../pages/NewApplicationPage/types';
import { RegionType } from '../pages/NewExpertPage/types';

export const sortPublishers = (x: PublisherType, y: PublisherType) => {
  if (x.title < y.title) {
    return -1;
  } else if (x.title > y.title) {
    return 1;
  }

  return 0;
};

export const sortStatus = (x: StatusType, y: StatusType) => {
  if (x.name < y.name) {
    return -1;
  } else if (x.name > y.name) {
    return 1;
  }

  return 0;
};

export const sortRegions = (x: RegionType, y: RegionType) => {
  if (x.title < y.title) {
    return -1;
  } else if (x.title > y.title) {
    return 1;
  }

  return 0;
};

export const sortLanguages = (x: LanguageType, y: LanguageType) => {
  if (x.title < y.title) {
    return -1;
  } else if (x.title > y.title) {
    return 1;
  }

  return 0;
};

export const sortSchoolClasses = (x: SchoolClassType, y: SchoolClassType) => {
  if (x.title < y.title) {
    return -1;
  } else if (x.title > y.title) {
    return 1;
  }

  return 0;
};

export const sortSubjectAreas = (x: SubjectAreaType, y: SubjectAreaType) => {
  if (x.title < y.title) {
    return -1;
  } else if (x.title > y.title) {
    return 1;
  }

  return 0;
};
